import {
    Backdrop,
    CircularProgress,
    Container,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    IconButton
} from "@material-ui/core";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { ArrowBack, Delete as DeleteIcon, Save as SaveIcon } from "@material-ui/icons";
import MUIDataTable from "mui-datatables";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import Select from "../../../components/Form/Select";
import SelectShedMovementType from "../../../components/Form/SelectShedMovementType";
import { Switch } from "../../../components/Form/Switch";
import TextField from "../../../components/Form/TextField";
import AlertDialog from "../../../components/ui/AlertDialog";
import ButtonUI from "../../../components/ui/ButtonUI";
import ConfirmModalUI from "../../../components/ui/ConfirmModalUI";
import PageTitle from "../../../components/ui/PageTitleUI";
import { useAuth } from "../../../hooks/auth";
import { MvmSchedule, MvmShedSchedule } from "../../../interfaces/Mvm";
import MvmStatus from "../../../interfaces/MvmStatus";
import { ShedSearch } from "../../../interfaces/Shed";
import MvmApi from "../../../services/MvmApi";
import OptionValueApi from "../../../services/OptionValueApi";
import ShedApi from "../../../services/ShedApi";
import WindowApi from "../../../services/WindowApi";
import utilsDate from "../../../utils/Date";
import permissions from '../../../utils/Permissions';
import getDefaultGridOptions from "../../../utils/componentUtils";
import { DialogTitle, PaperComponent, useStyles } from "../Style";
import MvmSummary from "../components/MvmSummary";
import SelectWindowForm from "./SelectWindowForm";
import { FIASA_PLANT_ID, FIAPE_PLANT_ID } from "../../../utils/constants";

interface IFormInput {
    mvmNumber: any;
    mvmNumberUnique: string;
    shed: any;
    shedMovementType: any;
    windowDate: any;
    selectedDeliveryDate: any;
    isTruckKanban?: boolean;
    // movementTypeDropBox: [];
    
}
const RegisterVehicleArrival: React.FC = () => {
    const history = useHistory();
    const classes = useStyles();
    const { t: tShed } = useTranslation("Shed");
    const { t: tGeneral } = useTranslation("General");
    const { t: tMvm } = useTranslation("Mvm");
    const { t: tValidation } = useTranslation("Validation");
    const { t: tWindow } = useTranslation("Window");
    const { enqueueSnackbar } = useSnackbar();
    const [mvmSheds, setMvmSheds] = useState<MvmShedSchedule[]>([]);
    const { user, hasPermission, isFiasa } = useAuth();
    const [openedPainel, setOpenedPainel] = useState<boolean>(false);
    const [isOpenAlert, setIsOpenAlert] = useState<boolean>(false);
    const [perimeters, setPerimeters] = useState<any>([]);
    const [selectedWindow, setSelectedWindow] = useState<any>(null);
    const [mvm, setMvm] = useState<any>(null);
    const [isShedXD, setIsShedXD] = useState<boolean>(false);
    const [sheds, setSheds] = useState<any>([]);
    const [circularLoading, setCircularLoading] = useState(false);
    const [queryMvmId, setQueryMvmId] = useState<any>(null);
    const methods = useForm<IFormInput>({
        defaultValues: {
            mvmNumber: {},
            shed: {},
            shedMovementType: {},
            mvmNumberUnique: "",
            isTruckKanban: false
            // movementTypeDropBox: []
        },
    });
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        clearErrors,
        setError,
    } = methods;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!hasPermission(permissions.CONCIERGE.Add) && !hasPermission(permissions.CONCIERGE.Manage))
            history.replace('NoPermission');
            
        if (mvm && mvm.companyId !== user.company.companyID)
            history.replace('/blank');
    }, [history, user]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        var mvmId = Number(
            window.location.pathname.replace("/RegisterVehicleArrival/", "")
        );
        if (!isNaN(mvmId)) setQueryMvmId(mvmId);
    }, [window.location.pathname]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const loadAsync = async () => {
            if (mvm === null) 
                return

            if (mvm.scheduleDate)
                setIsOpenAlert(true);
            
            //Tem NF Embalagem? Mandar receber antes.. Somente MVMs da Planta 1  enviam RackTypes ao MDR (por enquanto)
            if ( isFiasa() && mvm.invoices.find((inv: any) => inv.invoiceType === "E")) {
                setCircularLoading(true);
                const mvmLogs = await MvmApi.getMvmLogs(mvm.id, ['EVM', 'FEM']);

                if (!mvmLogs.find((mvm: any) => mvm.logType === "EVM" || mvm.logType === "FEM"))
                    history.replace(`/ExportRacks/${mvm.id}`);
                else
                    setCircularLoading(false);
            }

            if (mvm.deliveryWindowDate === null)
                compareDateForOpeningPanel(mvm.mvmNumber);

            truckKanban_change(mvm.isTruckKanban)
            
            var params: ShedSearch = {
                pageSize: 1000,
                plantId: Number(user.company.plantID),
            };

            setCircularLoading(true);
            await ShedApi.search(params)
                .then((result) => {
                    setSheds(result.items);
                })
                .finally(() => {
                    setCircularLoading(false);
                });

            //Sheds padrao: sugestao de sheds padrao do Mvm, que nao estejam na lista de sheds ja inclusos no mvm (ex: Pra JEEP, o backend envia a sugestao de ter o galpao de Carga CSC e os Descarga, baseado nos galpoes dos desenhos):
            let defaultSheds = mvm.defaultSheds?.filter((defaultShed:any) => !mvm.sheds.some((mvmShed:any) => mvmShed?.shedCode === defaultShed?.shedCode && mvmShed?.movementTypeId === defaultShed?.movementTypeId )) || [];
            
            defaultSheds.map((f: any) => {
                f.movementTypeId = null
                f.movementTypeDescription = null
                return f
            })

            //Sheds para apresentar na tela: os sheds padrao + os do mvm:
            let arrMvmSheds = Array(0);
            arrMvmSheds = [ ...mvm.sheds, ...defaultSheds];

            var count = 1;
            var arryMvmSheds = arrMvmSheds.map(
                (element: {
                    shedId: any;
                    shedCode: any;
                    shedType: any;
                    movementTypeId: any;
                    movementTypeDescription: any;
                    tolerance: any;
                }) => {
                    var newItem: MvmShedSchedule = {
                        order: count,
                        shedId: element.shedId,
                        shedCode: element.shedCode
                            .split("-")[0]
                            ?.trim(),
                        shedType: element.shedType,
                        movementTypeId: element.movementTypeId,
                        movementTypeDescription:
                            element.movementTypeDescription,
                        tolerance: element.tolerance
                    };

                    count++;
                    return newItem;
                }
            )
            setMvmSheds(arryMvmSheds);

            OptionValueApi.search("AePerimetroJanela")
                .then((response) => {
                    if (response) {
                        var perimetersTemp = response.map(
                            (item: any) => item.description
                        );
                        setPerimeters(perimetersTemp);
                    }
                })
                .finally(() => {
                    setCircularLoading(false);
                });

            
            if (mvm?.windowId || mvm?.deliveryWindowDate)
                bindWindow({
                    window: {
                        deliveryWindowDate: mvm?.deliveryWindowDate,
                        deliveryWindowDateString: utilsDate.DateTimeShort(mvm?.deliveryWindowDate),
                        id: mvm?.windowId
                    },
                    unforeseenReason: mvm?.unforeseenReason
                })

            setCircularLoading(false);
        };

        loadAsync();
    }, [mvm]);

    const onSummaryChange = async (data: any) => {
        setCircularLoading(true);

        if (!data) {
            setMvm(null);
            return;
        }

        setMvm(data);
    };

    const renderMovementTypeBox = (row: any) => {
        if (row.data) {
            const tableMeta = row;
            var id = tableMeta.data[0];
            var shedId = tableMeta.data[1];
            var movementTypeId = tableMeta.data[2];

            // Listagem do Select
            var movementTypes = sheds
            .filter((e: { id: number }) => e.id === (mvmSheds.find(i => i.order === id)?.shedId))[0]
                ?.movementTypes.map((item: any) => ({
                    movementTypeId: item.movementType.id,
                    movementTypeDescription: item.movementType.description,
                    tolerance: item.tolerance,
                    code: item.movementType.id,
                    label: item.movementType.description,
                }));

            // Encontrando o MovementType a preencher o Select
            var movementType = movementTypes.find((x: any) => x.movementTypeId === movementTypeId);
            
            return (
                <Select
                    style={{ width: "100%", padding: 0, margin: 0 }}
                    marginGird="6px"
                    label={tShed("movementType")}
                    name={`movementTypeDropBox_${shedId}-${id}`}
                    key={`movementTypeDropBox_${shedId}-${id}`}
                    defaultValue={movementType}
                    control={control}
                    allowSelectValueNotFound={false}
                    options={movementTypes}
                    onChange={(value:any) => onChangeMovementType(id, value)}
                />
            );
        }
    };

    const onChangeMovementType = (order: number, value: any) => {
        var sheds:MvmShedSchedule[] = mvmSheds.map((shed) => {
            if (shed.order === order) {
                shed.movementTypeDescription = value?.movementTypeDescription
                shed.movementTypeId = value?.movementTypeId
                shed.tolerance = value?.tolerance

                validateNewShed(shed)

                return shed
            }
            else
                return shed;
        })
        setLoadingShedList(true)
        setMvmSheds(sheds);
    }

    const [columnsShedList, setColumnsShedList] = useState<any>([])
    const [loadingShedList, setLoadingShedList] = useState<boolean>(false)
    const [itemIndexDelete, setItemIndexDelete] = useState<number>(0)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {

        if (itemIndexDelete > 0) {
            var itemsTemp = mvmSheds.filter((element) => element.order !== itemIndexDelete)

            var order = 1
    
            itemsTemp.forEach((element) => {
                element.order = order;
                order++;
            })
    
            setMvmSheds(itemsTemp)
    
            enqueueSnackbar(tGeneral("returnSubmitDeleteFormSuccess"), {
                variant: "success",
            })

            setItemIndexDelete(0)
        }

        var columns = [
            {
                name: "order",
                options: {
                    display: false,
                },
            },
            {
                name: "shedId",
                options: {
                    display: false,
                },
            },
            {
                name: "movementTypeId",
                options: {
                    display: false,
                },
            },
            {
                name: "shedCode",
                label: String(tShed("shed")),
                options: {
                    customBodyRender: (
                        value: any,
                        tableMeta: any,
                        updateValue: any
                    ) => {
                        var splited = value.split(" - ");
                        if (splited[1] === undefined) splited[1] = tableMeta.rowData[8]; //se ja nao vier o tipo no valor, pegar da coluna da tabela
                        return (
                            splited[0] +
                            " - " +
                            (splited[1] === "D"
                                ? tWindow("unload")
                                : tWindow("load"))
                        );
                    },
                },
            },
            {
                name: "movementTypeDescription",
                label: String(tShed("movementType")),
                options: {
                    display: false,
                    sort: false,
                    setCellHeaderProps: () => ({
                        align: "center",
                    }),
                    setCellProps: () => ({
                        align: "center",
                    }),
                },
            },
            {
                name: "",
                options: {
                    sort: false,
                    setCellProps: () => ({
                        align: "center",
                    })
                },
            },
            {
                name: "",
                options: {
                    sort: false,
                    setCellProps: () => ({
                        align: "right",
                    }),
                    customBodyRender: (
                        value: any,
                        tableMeta: any,
                        updateValue: any
                    ) => renderButtons(tableMeta),
                },
            },
            {
                name: "tolerance",
                options: {
                    display: false,
                },
            },
            {
                name: "shedType",
                options: {
                    display: false,
                },
            },
        ]

        setColumnsShedList(columns)
        setLoadingShedList(false)
    }, [loadingShedList])

    const renderButtons = (tableMeta: any) => {
        return (
            <AlertDialog
                dialogTitle={tGeneral("dialogDeleteTitle")}
                dialogContentText={tGeneral("dialogDeleteContentText")}
                cancelTextButton={tGeneral("cancelDeleteTextButton")}
                confirmTextButton={tGeneral("confirmDeleteTextButton")}
                confirmDialogFunction={() => {
                    setItemIndexDelete(tableMeta.rowData[0])
                    setLoadingShedList(true)
                }}
                Button={
                    <IconButton size="small" edge="end">
                        <DeleteIcon />
                    </IconButton>
                }
            />
        );
    };
    
    const formValidation = async (data: any) => {
        var result = false;
        clearErrors("shed");
        clearErrors("shedMovementType");
        try {
            const schema = Yup.object().shape({
                shed: Yup.object()
                    .nullable()
                    .required(tValidation("requiredField"))
                    .shape({
                        code: Yup.string().required(
                            tValidation("requiredField")
                        ),
                    }),
                shedMovementType: Yup.object()
                    .nullable()
                    .required(tValidation("requiredField"))
                    .shape({
                        code: Yup.string().required(
                            tValidation("requiredField")
                        ),
                    }),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            result = true;
        } catch (err) {
            var errors: string[] = [];

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    if (
                        errors.filter((element) =>
                            element.includes(error.message)
                        ).length === 0
                    )
                        errors.push(error.message);

                    setError(
                        error.path?.split(".")[0] as
                            | "shed"
                            | "shedMovementType",
                        { message: error.message }
                    );
                });

                errors.forEach((element) => {
                    if (element === tValidation("requiredField"))
                        enqueueSnackbar(tGeneral("requiredFieldsValidation"), {
                            variant: "warning",
                        });
                    else enqueueSnackbar(element, { variant: "warning" });
                });
            }

            result = false;
        }

        return result;
    };

    const addItemOnList = async () => {
        var data = getValues();

        if (!(await formValidation(data))) return;

        var newValue: MvmShedSchedule = {
            order: mvmSheds.length + 1,
            shedId: Number(data.shed.code),
            shedCode: data.shed.label.split("-")[0]?.trim(),
            shedType: data.shed.shedType,
            movementTypeId: data.shedMovementType.code,
            movementTypeDescription: data.shedMovementType.label,
            tolerance: data.shedMovementType.tolerance
        };
        setValue("shed", {});
        setValue("shedMovementType", {});

        if (!validateNewShed(newValue))
            return

        setLoadingShedList(true)
        setMvmSheds([...mvmSheds, newValue]);
        
    };

    const validateNewShed = (newValue: MvmShedSchedule): boolean => {
        if (isShedXD && newValue.shedType.toUpperCase() === "D") {
            enqueueSnackbar(tShed("newShedDeployOnSpaceXdConfigValidation"), {
                variant: "warning",});
            return false
        }

        var shedAlreadyInserted = mvmSheds.filter(
            (element) =>
                element.order !== newValue.order &&
                element.shedCode === newValue.shedCode &&
                element.movementTypeId === newValue.movementTypeId
        ).length > 0

        if (shedAlreadyInserted) {
            enqueueSnackbar(tShed("shedAlreadyInserted"), {
                variant: "warning",});
            return false
        }

        return true
    }

    const configureShedsToRecord = () => {
        var data = getValues() as Record<string, any>;

        mvmSheds.forEach((element, index) => {
            element.order = index + 1;
            var newMovementType = data["movementTypeDropBox" + element.order];
            if (newMovementType?.code) {
                element.movementTypeId = newMovementType.code;
                element.movementTypeDescription = newMovementType.label;
            }
        });
    };

    const validateShedsToSave = (sheds: MvmShedSchedule[]): boolean => {
        var invalidSheds = sheds.filter(f => !f.movementTypeId)
        var response = invalidSheds.length === 0

        if (!response)
            enqueueSnackbar(tShed("selectShedsMovementTypeToContinue"), {
                variant: "warning",})

        return response
    }

    const recordScheduleRack = () => {
        configureShedsToRecord();
        if (!validateShedsToSave(mvmSheds))
            return

        setCircularLoading(true);

        let model: MvmSchedule = {
            id: mvm.id,
            companyId: Number(user.company.companyID),
            conciergeCode: mvm.conciergeCode,
            plantId: Number(user.company.plantID),
            sheds: mvmSheds,
            windowId: mvm.windowId,
            windowStatus: mvm.windowStatus,
            deliveryWindowDate: mvm.deliveryWindowDate,
            unforeseenReason: 0,
            isTruckKanban: getValues().isTruckKanban
        };

        if (selectedWindow) {
            if (selectedWindow.window) {
                model.deliveryWindowDate = selectedWindow.window.deliveryWindowDate;
                model.windowId = selectedWindow.window.id;
                model.unforeseenReason = null;
            } else {
                model.deliveryWindowDate = null;
                model.windowId = null;
                model.unforeseenReason = selectedWindow.unforeseenReason;
            }
        } else {
            model.deliveryWindowDate = mvm.deliveryWindowDate;
            model.windowId = mvm.windowId;
            model.unforeseenReason = mvm.unforeseenReason;
        }

        MvmApi.recordScheduleRack(model)
            .then(() => {
                enqueueSnackbar(tGeneral("returnSubmitEditFormSuccess"), {
                    variant: "success",
                });
                history.push("/Manage");
            })
            .finally(() => {
                setCircularLoading(false);
            });
    };

    const onSubmit = (data: any) => {};

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: mvmSheds.length > 0 ? "pointer" : "",
                },
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 8,
                    paddingRight: 4,
                    paddingBottom: 6,
                    paddingTop: 6,
                },
                head: {
                    padding: 8,
                }
            },
        },
    });

    const bindWindow = (data: any) => {
        setValue(
            "selectedDeliveryDate",
            data.window ? data.window.deliveryWindowDateString : ""
        );
        setSelectedWindow(data);

    };

    function compareDateForOpeningPanel(mvmNumber: string) {
        var date = new Date();

        setCircularLoading(true);
        let params = {
            suppliersId: mvm?.shippingSupplierId.toString(),
            companyId: user.company.companyID,
            PageSize: 1000,
            PageIndex: 0,
            flagSunday: date.getDay() === 0 ? true : null,
            flagMonday: date.getDay() === 1 ? true : null,
            flagTuesday: date.getDay() === 2 ? true : null,
            flagWednesday: date.getDay() === 3 ? true : null,
            flagThursday: date.getDay() === 4 ? true : null,
            flagFriday: date.getDay() === 5 ? true : null,
            flagSaturday: date.getDay() === 6 ? true : null,
        };

        validateWindows(params, mvmNumber, date);

        setCircularLoading(false);
    }

    const validateWindows = async (params: any, mvmNumber: any, date: any) => {
        var dateCompare = utilsDate.ConvertDateToStringYYYYMMDD(date)
        await WindowApi.searchWindow(params)
            .then(async (allWindows) => {
                if (allWindows.items.length > 0) {
                    await MvmApi.searchTakenDeliveryWindows(user.company.companyID, mvm?.shippingSupplierId.toString(), dateCompare).then(
                        (takenWindows) => {
                            if (
                                takenWindows.filter(
                                    (x: any) => x.mvmNumber === mvmNumber
                                ).length > 0
                            )
                                setOpenedPainel(false);
                            else setOpenedPainel(true);

                            // takenWindows.forEach((element: { windowId: any; mvmNumber: any }) => {
                            //     if (allWindows.items.filter((x: any) => x.id !== element.windowId) && element.mvmNumber !== mvmNumber)
                            //         setOpenedPainel(true);
                            //     else
                            //         setOpenedPainel(false);
                            // })
                        }
                    );
                } else setOpenedPainel(false);
            })
            .catch(() => setCircularLoading(false));
    };

    const truckKanban_change = (isTruckKanban: boolean) => {
        setValue("isTruckKanban", isTruckKanban);
        setIsShedXD(isTruckKanban);

        // Espaco XD: Remover todos os galpoes de descarga e deixar somente o XD no lugar
        if (isTruckKanban)
        {
            const xdShed = sheds.filter((shed:any) => shed.code === "XD");
            if (xdShed.length > 0)
            {
                let currentSheds = mvmSheds.filter((shed:any) => shed.shedType !== "D");
                currentSheds = [{
                    order: 1,
                    shedCode: xdShed[0].code,
                    shedId: xdShed[0].id,
                    shedType: xdShed[0].type,
                    movementTypeDescription: xdShed[0].movementTypes[0].movementType.description,
                    movementTypeId: xdShed[0].movementTypes[0].movementType.id,
                    tolerance: xdShed[0].movementTypes[0].tolerance
                }, ...currentSheds];

                currentSheds.forEach((shed:any, index: number) => { shed.order = index + 1; }); //recalcular a ordem dos galpoes
                
                setLoadingShedList(true)
                setMvmSheds(currentSheds);
                
            }
        }
    }

    const onDragEnd = (result: any) => {
        // como eu faço para atualizar a ordem no mvmSheds com a nova ordem?
        const { destination, source, draggableId: _draggableId } = result;
        if (!destination) {
            return;
        }

        if (destination.index === source.index) {
            return;
        }
        
        const newSheds = Array.from(mvmSheds);
        newSheds.splice(source.index, 1);
        newSheds.splice(destination.index, 0, mvmSheds[source.index]);

        for (var i = 0; i < newSheds.length; i++) {
            newSheds[i].order = i+1
        }

        setLoadingShedList(true)
        setMvmSheds(newSheds);
        
    };

    return (
        <Container maxWidth={false} component="main">
            <ConfirmModalUI
                isOpen={isOpenAlert}
                mensage="MVM já registrado. Deseja editar?"
                onClose={() => history.replace(`/Manage`)}
                onCloseConfirmModal={() => setIsOpenAlert(false)}
            />  
            <Dialog
                style={{ maxWidth: "100%" }}
                open={openedPainel}
                aria-labelledby="form-dialog-title"
                PaperComponent={PaperComponent}
                fullWidth
            >
                <DialogTitle
                    classes={{ root: classes.dialogTitle }}
                    id="draggable-dialog-title"
                    onClose={() => setOpenedPainel(false)}
                >
                    {tMvm("selectWindow")}
                </DialogTitle>

                <DialogContent>
                    <SelectWindowForm
                        supplierId={mvm?.shippingSupplierId}
                        supplierDescription={mvm?.shippingSupplierCorporateName}
                        perimeterList={perimeters}
                        windowDate={selectedWindow?.window?.deliveryWindowDate}
                        clickHandlerClose={() => setOpenedPainel(false)}
                        onSelectWindow={bindWindow}
                        unforeseenReason={selectedWindow?.unforeseenReason}
                    />
                </DialogContent>
            </Dialog>
            <PageTitle
                title={
                    tMvm("registerVehicleArrival") +
                    (mvm ? " - " + mvm?.mvmNumber : "")
                }
            />
            <div className={classes.rootContent}>
                <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Divider style={{ marginTop: "10px" }} />
                    <MvmSummary
                        control={control}
                        name={"summary"}
                        onChange={onSummaryChange}
                        setValue={setValue}
                        queryMvmId={queryMvmId}
                        mvmStatus={[MvmStatus.FLAG_STATUS_PENDING_ENTRANCE]}
                        screen="RegisterVehicleArrival"
                        includeProperties={["Sheds", "Invoices"]}
                    />
                    {!mvm ? (
                        <></>
                    ) : (
                        <>
                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <TextField
                                        label={tMvm("deliveryWindowDate")}
                                        name="selectedDeliveryDate"
                                        control={control}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true,
                                            classes: {
                                                input: classes.inputBlocked,
                                            },
                                        }}
                                    />
                                </Grid>
                                {+user.company.plantID !== FIAPE_PLANT_ID &&
                                <Grid style={{ marginLeft: 5, marginTop: 5 }}>
                                    <ButtonUI
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => setOpenedPainel(true)}
                                    >
                                        {tMvm("windowSelect")}
                                    </ButtonUI>
                                </Grid>}
                                <Grid item xs={2} style={{ display: +user.company.plantID !== FIASA_PLANT_ID ? 'none' : ''}}>
                                    <Switch
                                        disabled={mvm.isBloquedXD !== undefined && mvm.isBloquedXD}
                                        label={tMvm("xdShed")}
                                        labelPlacement="top"
                                        name="isTruckKanban"
                                        control={control}
                                        checked={getValues().isTruckKanban}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => truckKanban_change(e.target.checked)} />  
                                        
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <SelectShedMovementType
                                    nameSelectShed={"shed"}
                                    nameSelectMovementType={"shedMovementType"}
                                    control={control}
                                    setValue={setValue}
                                    title={tShed("shedRoutes")}
                                    showConfirmButton={true}
                                    onButtonClick={addItemOnList}
                                />
                            </Grid>
                            <Grid
                                style={{
                                    marginTop: 5,
                                    width: "98%",
                                    marginLeft: 10,
                                    marginBottom: 10,
                                }}>
                            {!loadingShedList && <MuiThemeProvider theme={myTheme}>
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <Droppable droppableId="droppable">
                                        {(provided: any) => (
                                        <div {...provided.droppableProps} ref={provided.innerRef}>
                                        <MUIDataTable
                                            title=""
                                            data={mvmSheds}
                                            columns={columnsShedList}
                                            components={{
                                                TableBody: (props) =>
                                                {
                                                    return (
                                                        <div style={{minHeight: mvmSheds.length*60}}>
                                                            {props.data.map((row: any, index: any) => (
                                                                    <Draggable key={row.data[0]} draggableId={row.data[0].toString()} index={index}>
                                                                    {(provided: any) => (
                                                                        <div ref={provided.innerRef}
                                                                        style={{width: '100%!important',flex: 1, display: 'flex', flexDirection: 'row'}}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}>
                                                                            <div  style={{display: 'flex', flexDirection: 'row', width: '115%', marginBottom: 10, paddingBottom: 6,
                                                                        borderBottom: '1px solid #CCC'}}>
                                                                                <div style={{display: 'flex', flex: 1, alignItems: 'center', paddingLeft: 10}}>{row.data[3]}</div>
                                                                                <div style={{display: 'flex', flex: 1}}>{renderMovementTypeBox(row)}</div>
                                                                                <div style={{display: 'flex', flex: 1, maxWidth: 40}}>{row.data[6]}</div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    </Draggable>
                                                            ))}
                                                        </div>
                                                    )

                                                },
                                            }}
                                            options={{
                                                ...getDefaultGridOptions(tGeneral),
                                                serverSide: false,
                                                pagination: false,
                                                sort: false,
                                                // sortOrder: {
                                                //     name: "order",
                                                //     direction: "asc",
                                                // },
                                                selectToolbarPlacement: "none",
                                                filter: false,
                                                search: false,
                                                download: false,
                                                print: false,
                                                viewColumns: false,
                                                selectableRows: "none",
                                                
                                            }}
                                        />
                                        {provided.placeholder}
                                        </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </MuiThemeProvider>}
                            </Grid>
                            <Backdrop
                                style={{ zIndex: 9999 }}
                                open={circularLoading}
                            >
                                <CircularProgress color="inherit" />
                            </Backdrop>
                            <ButtonUI
                                style={{ marginTop: 15 }}
                                variant="outlined"
                                color="secondary"
                                onClick={() => history.replace("/Manage")}
                                startIcon={<ArrowBack />}
                            >
                                {tGeneral("back")}
                            </ButtonUI>
                            <ButtonUI
                                style={{ marginTop: 15 }}
                                variant="outlined"
                                color="primary"
                                onClick={() => recordScheduleRack()}
                                startIcon={<SaveIcon />}
                            >
                                {tGeneral("save")}
                            </ButtonUI>
                        </>
                    )}
                </form>
                </FormProvider>
            </div>
        </Container>
    );
};
export default RegisterVehicleArrival;
